module.exports = __webpack_public_path__ + "static/og-85dc17d2fc80661808e0842fa554b4d3.png";